import { Link } from 'react-router'
import { Section, SectionWrapper } from '@/components/layout/Section'
import { LargeText } from '@/components/ui/typography'

/*
 * The 404.
 *
 * Was styled entirely with inline `style={{}}` objects — `maxWidth: 720`,
 * `padding: '48px 24px'`, `fontSize: 28` — which is non-negotiable §1's third
 * clause, and it passed every gate for the life of the port because the only
 * style check looked for colour literals and a style object rarely holds one.
 * `check:tokens` now has an inline-style check; this was its one finding.
 *
 * Rebuilt on the same spine as every other page. `<h1>` already carries its
 * size from globals.css, so the hand-set 28px goes away with the rest.
 */
export function NotFound() {
  return (
    <Section as="div" paddingTop="md" paddingBottom="2xl">
      <SectionWrapper layout="stack" width="content">
        <h1 className="m-0">Page not found</h1>
        <LargeText tone="default">
          That URL does not exist. It may have moved, or the link that brought you here may be out
          of date.
        </LargeText>
        <p className="m-0">
          <Link to="/" className="text-blue underline">
            Back to home
          </Link>
        </p>
      </SectionWrapper>
    </Section>
  )
}
